export const frybread = {
  id: "frybread",
  link: "/#/recipes/recipes/frybread",
  name: "Herdazian Frybread",
  cuisine: "Herdazian",
  summary: "Crispy fried flatbread topped with avocado",
  inspiration: "Avocado Toast",
  quantity: "4 frybreads",
  time: "30 minutes",
  notes:
    "The books mention fried Herdazian bread, but don't give us much more than that. So I decided to go with basically a deep fried tortilla, since it's similar to what I'm using for chouta. I wanted to include toppings, though. Without them it didn't feel like a complete dish. I went with avocado since I'm using avocados already in other recipes, and the creaminess contrasts well with the crunch frybread. I decided to include 2 options for additional toppings, both to add flavor as well as make the dish feel a little more alien and unique, and not simply \"tostadas and avocados.\" Feel free to experiment with the toppings. These are only 2 suggestions.",
  quotes:
    "Lunch had ended, though that didn't stop Lhan from snatching a plate of fried bread, Herdazian style, from the counter as they passed. (Words of Radiance interlude I12",
  image: "https://jozomby-public.s3.amazonaws.com/recipes/frybread-overview.jpg",
  ingredientSections: [
    {
      title: "Bread",
      ingredients: [
        {
          item: "maseca",
          display: "1 cup Mexican-style corn flour (Maseca), plus additional"
        },
        {
          item: "water",
          display: "3/4 cup water"
        },
        {
          item: "avocado",
          display: "2 avocados"
        },
        {
          item: "vegetableOil",
          display: "Vegetable oil for frying"
        }
      ]
    },
    {
      title: "First topping option",
      ingredients: [
        {
          item: "onion",
          display: "1/2 red onion"
        },
        {
          item: "cucumber",
          display: "1/2 cucumber"
        },
        {
          item: "salt",
          display: "a pinch of salt"
        }
      ]
    },
    {
      title: "Second topping option",
      ingredients: [
        {
          item: "onion",
          display: "6 green onions"
        },
        {
          item: "gochugaru",
          display: "gochugaru to taste"
        }
      ]
    }
  ],
  steps: [
    "In a bowl, combine maseca and water. Mix well and knead into a ball. Divide into 4. Heat a deep frier to 350 degrees Fahrenheit. Sprinkle some maseca on your work surface.",
    "One ball at a time, roll the ball into a 6 inch disk with a rolling pin. Place in the deep frier and fry for a minute or until it puffs up. Flip it over and fry for a couple minutes on that side until it's crispy. You may need to push it down to submerge it in the oil. Drain on paper towels.",
    "For the toppings, slice the avocadoes. Peel and finely dice the cucumber and red onion. Mix the cucumber and red onion together along with the pinch of salt. Chop the green onions.",
    "To serve, place one quarter of the avocado slices on each fried bread, then top with either the cucumber mixture or the green onions. If you use the green onions, also sprinkle on gochugaru to taste."
  ]
}
